// extracted by mini-css-extract-plugin
export default {"title":"_7148f86dce","inner_title":"_813ecca2f4","charge_btn":"_5f92ad9db8"};